import React, { memo } from "react";
import PropTypes from "prop-types";
import { Button, ButtonGroup } from "@chakra-ui/react";
import * as PostEditorActions from "./PostEditorActions.constants";
import { translate as trans } from "../Trans/Trans";

const PostEditorCreateDraftPostButtons = ({
  isLoading,
  isDisabled,
  onAddDraft,
  onAddForApprovalDraft,
}) => (
  <ButtonGroup size="sm">
    <Button
      variant="solid"
      onClick={onAddDraft}
      isDisabled={isDisabled || !!isLoading}
      isLoading={isLoading === PostEditorActions.ADD_DRAFT}
    >
      {trans("post_editor.actions.add_draft")}
    </Button>
    {onAddForApprovalDraft ? (
      <Button
        variant="solid"
        onClick={onAddForApprovalDraft}
        isDisabled={isDisabled || !!isLoading}
        isLoading={isLoading === PostEditorActions.ADD_FOR_APPROVAL_DRAFT}
      >
        {trans("post_editor.actions.add_for_approval_draft")}
      </Button>
    ) : null}
  </ButtonGroup>
);

PostEditorCreateDraftPostButtons.propTypes = {
  isLoading: PropTypes.oneOf(Object.values(PostEditorActions)),
  isDisabled: PropTypes.bool,
  onAddDraft: PropTypes.func,
  onAddForApprovalDraft: PropTypes.func,
};

PostEditorCreateDraftPostButtons.defaultProps = {
  isLoading: undefined,
  isDisabled: undefined,
  onAddDraft: undefined,
  onAddForApprovalDraft: undefined,
};

export default memo(PostEditorCreateDraftPostButtons);
